module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-infiniti.76e3defa.jpg";